export const LOGICAL_WIDTH = 720;
// iOS reference is 1206×2622 (≈9:19.5). Web port uses a less extreme 9:16
// portrait so the canvas FITs more naturally inside a desktop browser
// window. Internal HEADER/BOARD/FOOTER ratios unchanged.
export const LOGICAL_HEIGHT = 1280;

// Absolute pixel breakpoints. HEADER positions the ground/trees image; BOARD
// is sized so 8 square cells of width=720/7 fit exactly (8 * 102.857 ≈ 823).
// FOOTER fills the remainder.
const HEADER_HEIGHT = 260;
const BOARD_HEIGHT = Math.round((LOGICAL_WIDTH / 7) * 8);
const FOOTER_HEIGHT = LOGICAL_HEIGHT - HEADER_HEIGHT - BOARD_HEIGHT;

export interface Rect {
  x: number;
  y: number;
  width: number;
  height: number;
}

export interface LayoutRegions {
  header: Rect;
  board: Rect;
  footer: Rect;
}

export function regions(): LayoutRegions {
  const boardH = LOGICAL_HEIGHT - HEADER_HEIGHT - FOOTER_HEIGHT;
  return {
    header: { x: 0, y: 0, width: LOGICAL_WIDTH, height: HEADER_HEIGHT },
    board: { x: 0, y: HEADER_HEIGHT, width: LOGICAL_WIDTH, height: boardH },
    footer: { x: 0, y: HEADER_HEIGHT + boardH, width: LOGICAL_WIDTH, height: FOOTER_HEIGHT },
  };
}
